import React from 'react'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import {
  TopInfoBox,
  TopInfoRight,
  StyledTermContainer,
  StyledTermContent
} from 'components/insightContent/visualization/InfoBox/index.css'
import { InsightContentSettingType } from 'components/insightContent/types'
import AccordionGroup from 'components/insightContent/visualization/AccordionGroup'
import AccordionSectionType from 'components/insightContent/enum/AccordionSectionType'
import { getInsightContentTypeDisplayText } from 'components/insightContent/utils/utils'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import InsightDialog from 'components/insightContent/visualization/InsightDialog'
import GoToAnalysisButton from 'components/insightContent/visualization/GoToAnalysisButton'

const DIALOG_CONTENT_HEIGHT = '460px'

interface InsightModalProps {
  open: boolean
  onClose: () => void
  title?: string
  selectedInsights?: InsightData[]
  widgetSettingWithSelection?: any
  detailSetting?: InsightContentSettingType
  isAudienceQuery?: boolean
}

const InsightModal = ({
  open,
  title,
  selectedInsights,
  onClose,
  widgetSettingWithSelection,
  detailSetting,
  isAudienceQuery
}: InsightModalProps) => {
  const theme = useDisplayTheme() as Theme

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSettingWithSelection))
  }

  return (
    <InsightDialog open={open} onClose={onClose}>
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <TopInfoBox mode={theme}>
        {selectedInsights?.map((item: InsightData) => (
          <StyledTermContainer key={item.topicName}>
            <StyledTermContent mode={theme}>{item.topicName}</StyledTermContent>
          </StyledTermContainer>
        ))}
        <TopInfoRight>
          <GoToAnalysisButton onClick={() => goToAnalysis()} />
        </TopInfoRight>
      </TopInfoBox>
      <Dialog.DialogContent height={DIALOG_CONTENT_HEIGHT}>
        <AccordionGroup
          insightContentsConfig={[
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SUMMARY),
              accordionContents: [
                {
                  insightContentType: InsightContentType.TOPIC_COMPARISON,
                  detailSetting,
                  isAudienceQuery
                }
              ]
            },
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SOUND_BITE),
              accordionContents: [
                {
                  insightContentType: InsightContentType.SOUND_BITE,
                  detailSetting
                }
              ]
            }
          ]}
        />
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </InsightDialog>
  )
}

export default InsightModal
